import { render, staticRenderFns } from "./CInterpreterName.vue?vue&type=template&id=2ebbab6e&scoped=true&"
import script from "./CInterpreterName.vue?vue&type=script&lang=js&"
export * from "./CInterpreterName.vue?vue&type=script&lang=js&"
import style0 from "./CInterpreterName.vue?vue&type=style&index=0&id=2ebbab6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebbab6e",
  null
  
)

export default component.exports